import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeUnauthorizationComponent } from './home/home-unauthorization/home-unauthorization.component';
import { OAuthCallbackComponent } from './core/oauth-callback.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full', data: { pageTitle: 'Home'} },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { pageTitle: 'Home'}
  },
  {
    path: 'patientdata',
    loadChildren: () => import('./patient-data/patient-data.module').then(m => m.PatientDataModule),
    data: { pageTitle: 'Patient Data'}
  },
  {
    path: 'import',
    loadChildren: () => import('./import/import.module').then(m => m.ImportModule),
    data: { pageTitle: 'Import'}
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    data: { pageTitle: 'Reports'}
  },
  {
    path: 'exports',
    loadChildren: () => import('./exports/exports.module').then(m => m.ExportsModule),
    data: { pageTitle: 'Exports'}
  },
  {
    path: 'hospitaladministration',
    loadChildren: () => import('./hospital-administration/hospital-administration.module').then(m => m.HospitalAdministrationModule),
    data: { pageTitle: 'Facility Administration'}
  },
  {
    path: 'systemadministration',
    loadChildren: () => import('./system-administration/system-administration.module').then(m => m.SystemAdministrationModule),
    data: { pageTitle: 'System Administration'}
  },
  {
    path: 'learning',
    loadChildren: () => import('./learning/learning.module').then(m => m.LearningModule),
    data: { pageTitle: 'Learning'}
  },
  {
    path: 'more',
    loadChildren: () => import('./more/more.module').then(m => m.MoreModule),
    data: { pageTitle: 'More'}
  },
  {
    path: 'logout',
    loadChildren: () => import('./logout/logout.module').then(m => m.LogoutModule),
    data: { pageTitle: null }
  },
  {
    path: 'displaypdf',
    loadChildren: () => import('./display-pdf/display-pdf.module').then(m => m.DisplayPdfModule),
    data: { pageTitle: null }
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    data: { pageTitle: null }
  },
  {
    path: 'unauthorized',
    component: HomeUnauthorizationComponent,
    data: { pageTitle: null }
  },
  {
    path: 'callback',
    component: OAuthCallbackComponent,
    data: { pageTitle: null }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
